import { render, staticRenderFns } from "./TechnologyTemplate.vue?vue&type=template&id=3453a7f7&scoped=true"
import script from "./TechnologyTemplate.vue?vue&type=script&lang=js"
export * from "./TechnologyTemplate.vue?vue&type=script&lang=js"
import style0 from "./TechnologyTemplate.vue?vue&type=style&index=0&id=3453a7f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453a7f7",
  null
  
)

export default component.exports